export const selectCustomerPricingsByCustomer = (state, customerId) =>
  state.customerPricing && state.customerPricing.pricingsByCustomer
    ? state.customerPricing.pricingsByCustomer[customerId] || []
    : [];

export const selectCustomerPricingLoading = (state) =>
  state.customerPricing ? state.customerPricing.loading : 'idle';

export const selectCustomerPricingError = (state) =>
  state.customerPricing ? state.customerPricing.error : null;
